import React from 'react'

import { AcornsIcon } from '@acorns/icons'
import { useRemoteStrings } from '@acorns/web-utils'

import { ProductKey, SubscriptionPricingContentQuery } from 'generated/types'

import { Cell, Check, Dot, MatchValue } from './styled-components'

type Tier = NonNullable<
  SubscriptionPricingContentQuery['tierGroup']['tierOptions']
>[number]['tier']
type Product = NonNullable<Tier['bundles']>[number]['products'][number]

interface Props {
  tier: Tier
  currentProduct?: Product
  isGold: boolean
}

export const TierCell = (props: Props) => {
  const { getRemoteString } = useRemoteStrings()

  if (!props.currentProduct) {
    return <Cell isGold={props.isGold} isBundleHeader />
  }

  const currentProductKey = props.currentProduct.product.key
  const hasFeature = props.tier.products?.some((product) => {
    return product.key === currentProductKey
  })
  // we only display the bundles from the highest tier
  // EARN_PRIME and EARN_CHOICE only appear on select tiers and never on the same
  // to represent match percentages
  const isChoiceOverridingPrime =
    currentProductKey === ProductKey.EarnPrime &&
    !hasFeature &&
    props.tier.products?.some(
      (product) => product.key === ProductKey.EarnChoice,
    )

  let content = <Check icon={AcornsIcon.Icon.Checkmark} gold={props.isGold} />

  if (currentProductKey === ProductKey.LaterMatch && props.tier.matchProgram) {
    content = (
      <MatchValue gold={props.isGold}>
        {props.tier.matchProgram.matchPercentage}%
      </MatchValue>
    )
  } else if (currentProductKey === ProductKey.EarnPrime && hasFeature) {
    content = (
      <MatchValue gold={props.isGold}>
        {getRemoteString({ key: 'earn.reward_match.prime.percent' })}
      </MatchValue>
    )
  } else if (
    currentProductKey === ProductKey.EarnPrime &&
    isChoiceOverridingPrime
  ) {
    content = (
      <MatchValue gold={props.isGold}>
        {getRemoteString({ key: 'earn.reward_match.choice.percent' })}
      </MatchValue>
    )
  }

  return (
    <Cell isGold={props.isGold}>
      {hasFeature || isChoiceOverridingPrime ? content : <Dot>●</Dot>}
    </Cell>
  )
}
